import { createSlice } from "@reduxjs/toolkit";
import { get } from "lodash";


interface FormData {
  [step: string]: {
    [field: string]: any;
  };
}

export interface FormState {
  formData: FormData;
}

const initialState: FormState = {
  formData: {},
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    saveFormData: (
      state,
      action: {
        payload: {
          step: string;
          data: { [field: string]: any };
        };
      }
    ) => {
      const { step, data } = action.payload;
      state.formData[step] = { ...state.formData[step], ...data };
    },
    clearFormData: (state) => {
      state.formData = {};
    },
  },
});

export const { saveFormData,clearFormData } = formSlice.actions;
export const formReducer = formSlice.reducer;

// Selector to get form data for a specific step
export const getFormData = (state: { form: FormState }, step: string) => {
  return state.form.formData[step] || {};
};

export default formSlice.reducer;
